import * as React from 'react';
export var Toast = function (_a) {
    var title = _a.title, _b = _a.kind, kind = _b === void 0 ? 'success' : _b, icon = _a.icon, children = _a.children;
    return (React.createElement("div", { className: "toast message-frame ".concat(kind) },
        React.createElement("div", { className: "icon" },
            React.createElement("i", { className: icon })),
        React.createElement("div", { className: "content" },
            React.createElement("div", { className: "type" }, title),
            React.createElement("div", { className: "message" }, children))));
};
//# sourceMappingURL=index.js.map